/**
 * @desc 平台店铺应用表列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<ObjectMap>;
export function request(
  body: defs.basics.AppAccountRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/appAccount/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
